// Copyright (c) 2015, Daffy Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

import FileUploader from './file_uploader';

daffy.provide('daffy.ui');
daffy.ui.FileUploader = FileUploader;
